"use strict";

exports.__esModule = true;
var createOnFocus = function createOnFocus(name, focus) {
  return function () {
    return focus(name);
  };
};
exports.default = createOnFocus;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/events/createOnFocus.js
 ** module id = 443
 ** module chunks = 0
 **/